import { useState } from 'react';
import type { FaqItem } from '@/types/content';

export default function FaqSection({
  items,
  eyebrow = '常见问题',
  title = '关于爆料前线，你可能想问',
  subtitle = '把大家问得最多的几个问题整理在这里，如果还有别的疑问，欢迎直接联系我们。',
}: {
  items: FaqItem[];
  eyebrow?: string;
  title?: string;
  subtitle?: string;
}) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="border-t border-background-200 bg-background-100 py-12 md:py-16" aria-labelledby="faq-heading">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-200 px-3 py-1 text-xs text-secondary-900">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-question-line text-sm" />
              </span>
              {eyebrow}
            </span>
            <h2 id="faq-heading" className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {title}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{subtitle}</p>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {items.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.question} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                      >
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.question}</span>
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="border-t border-background-200 px-4 pb-4 pt-3 md:px-5">
                        <p className="text-sm leading-relaxed text-foreground-700">{item.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}